module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/_iterators.js
// module id = /bQp
// module chunks = 0